import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const DatagridStyled = styled(Datagrid)(({ theme }) => ({
  border: '1px solid #E0E0E0',
  borderRadius: '4px',
  borderBottom: 'none',
  '& .MuiTableCell-head': {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.secondary.main,
    backgroundColor: 'white',
  },
}));
